
export const getInvoiceStatColor = (payload = '') => {
  const key = payload.startsWith('#') ? payload.slice(1) : payload;

  const color_map = {
    '07f300': 'var(--confirmed)',
    "fffe00": "var(--confetti)",          // Orange
    "0000ff": "var(--jordyblue)",         // Blue
    "fd5b2c": "var(--crusta)",            // Red
    "ca0005": "var(--bittersweet)",       // Brown
    "666666": "var(--silver)",            // Silver
    "000000": "var(--emperor)",           // Black
  }

  return color_map[key];
}
export const getInCoStatusColor = (payload = '') => {
  const color_map = {
    'paid': 'var(--confirmed)',
    "open": "var(--confetti)",          // Orange
    "partially_paid": "var(--jordyblue)",         // Blue
    "due": "var(--crusta)",            // Red
    "overdue": "var(--bittersweet)",       // Brown
    "cancelled": "var(--silver)",            // Silver
    "bad_dept": "var(--emperor)",           // Black
  }

  return color_map[payload];
}
export const getInvoiceStatusColor = (payload = '') => {

  const color_map = {
    '07f300': '64C896',
    "fffe00": "E6DC64",
    "0000ff": "86C0F4",
    "fd5b2c": "FA8237",
    "ca0005": "FF6E6E",
    "666666": "C8C8C8",
    "000000": "505050",

  }

  // const color=color_map.find(e=>e.v1==payload)

  const colorToReturn = color_map[payload]

  return colorToReturn?colorToReturn:payload;
}